import React from "react";
import { Offcanvas, Badge } from "react-bootstrap";
import { FaExclamationTriangle } from "react-icons/fa";
import Moment from "react-moment";

const ViewStudyRequestManagementDetail = ({ Show, Hide, Title, requestData }) => {
  const StatusBadge = ({ status }) => {
    let className = "bg-secondary";
    let dotColor = "#6c757d";

    if (status === "pending") {
      className = "bg-warning text-dark";
      dotColor = "#ffc107";
    } else if (status === "approved") {
      className = "bg-success";
      dotColor = "#198754";
    } else if (status === "rejected") {
      className = "bg-danger";
      dotColor = "#dc3545";
    } else if (status === "cancelled") {
      className = "bg-secondary";
      dotColor = "#6c757d";
    } else if (status === "expired") {
      className = "bg-danger";
      dotColor = "#dc3545";
    } else if (status === "revoked") {
      className = "bg-danger";
      dotColor = "#dc3545";
    }
    return (
      <Badge
        className={`${className} text-capitalize hstack gap-1`}
        style={{ width: "fit-content", fontSize: 10 }}
      >
        <span
          className="d-inline-block rounded-circle"
          style={{ backgroundColor: dotColor }}
        ></span>
        {status}
      </Badge>
    );
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" size="lg">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title || `Request ${requestData?.id}`}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Request ID</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{requestData?.requestNumber}</small>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Site</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{requestData?.siteName}</small>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Subject</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{requestData?.subjectName}</small>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Request Type</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{requestData?.requestType}</small>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Urgency</span>
          </div>
          <div className="col-7">
            {requestData?.urgency === "emergency" ?
              <Badge
                className="bg-danger d-flex align-items-center gap-1"
                style={{ width: "fit-content", fontSize: 10 }}
              >
                <FaExclamationTriangle size={10} />
                Emergency
              </Badge>
              : requestData?.urgency === "urgent" ?
                <Badge
                  className="bg-warning text-dark d-flex align-items-center gap-1"
                  style={{ width: "fit-content", fontSize: 10 }}
                >
                  Urgent
                </Badge>
                :
                <Badge
                  className="bg-secondary d-flex align-items-center gap-1"
                  style={{ width: "fit-content", fontSize: 10 }}
                >
                  Routine
                </Badge>
            }
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Requested By</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{requestData?.requestByName}</small>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Submitted</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>
              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                {requestData?.createdAt}
              </Moment>
            </small>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Reason</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{requestData?.reason}</small>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Medical Justification</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{requestData?.medicalJustification}</small>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Approver</span>
          </div>
          <div className="col-7">
            <small style={{ fontSize: 12 }}>{requestData?.approverName}</small>
          </div>
        </div>

        <hr className="my-3" />

        <div className="row mb-2">
          <div className="col-5">
            <span style={{ fontSize: "13px", color: "#6c757d" }}>Status</span>
          </div>
          <div className="col-7">
            <StatusBadge status={requestData?.status} />
          </div>
        </div>

        {requestData?.status === "approved" && (
          <>
            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Approved By</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>{requestData?.approvedByName}</small>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Approved Date</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>
                  <Moment format="DD MMM YYYY | HH:mm" withTitle>
                    {requestData?.approvedDT}
                  </Moment>
                </small>
              </div>
            </div>
            
            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Access Duration</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>
                  {requestData?.accessDuration}
                </small>
              </div>
            </div>
          </>
        )}
        {requestData?.status === "cancelled" && (
          <>
            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Cancelled By</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>{requestData?.cancelledByName}</small>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Cancelled Date</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>
                  <Moment format="DD MMM YYYY | HH:mm" withTitle>
                    {requestData?.cancelledDT}
                  </Moment>
                </small>
              </div>
            </div>
          </>
        )}
        {requestData?.status === "rejected" && (
          <>
            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Rejected By</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>{requestData?.rejectedByName}</small>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Rejected Date</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>
                  <Moment format="DD MMM YYYY | HH:mm" withTitle>
                    {requestData?.rejectedDT}
                  </Moment>
                </small>
              </div>
            </div>
          </>
        )}
        {requestData?.status === "revoked" && (
          <>
            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Revoke By</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>{requestData?.revokedByName}</small>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-5">
                <span style={{ fontSize: "13px", color: "#6c757d" }}>Revoke Date</span>
              </div>
              <div className="col-7">
                <small style={{ fontSize: 12 }}>
                  <Moment format="DD MMM YYYY | HH:mm" withTitle>
                    {requestData?.revokedDT}
                  </Moment>
                </small>
              </div>
            </div>
          </>
        )}
        {!(requestData?.status === "pending" || requestData?.status === "revoked") &&
          <div className="row mb-2">
            <div className="col-5 text-capitalize">
              <span style={{ fontSize: "13px", color: "#6c757d" }}>{requestData?.status} Comment</span>
            </div>
            <div className="col-7">
              <small style={{ fontSize: 12 }}>{requestData?.decisionComment}</small>
            </div>
          </div>
        }
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ViewStudyRequestManagementDetail;